import auth from 'src/router/auth'
import Block from '../Block'
import NewBlock from '../NewBlock'
export default [
  {
    path: '/blocks',
    name: 'blocks',
    component: Block,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/blocks/new',
    name: 'create-blocks',
    component: NewBlock,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/block/routes/index.js